import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import Logo from './Logo';
import AnchorLink from './AnchorLink';
import { NAV } from '../content/site';

export default function MobileMenu({ open, onClose }) {
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    const onResize = () => { if (window.innerWidth >= 900) onClose(); };
    window.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div role="dialog" aria-modal="true" aria-label="Menu" className="fixed inset-0 z-[60] flex flex-col bg-accent px-5 pb-6 text-ink">
      <div className="flex h-header items-center justify-between border-b-2 border-ink">
        <Logo variant="onRed" as="span" />
        <button ref={closeRef} type="button" onClick={onClose} aria-label="Close menu" className="grid h-11 w-11 place-items-center bg-ink text-bg">
          <X size={20} aria-hidden="true" />
        </button>
      </div>
      <nav aria-label="Mobile" className="flex flex-col">
        {NAV.map(n => (
          <AnchorLink key={n.href} href={n.href} onClick={onClose} className="border-b-2 border-ink py-2.5 text-[44px] font-extrabold leading-none tracking-[-0.03em]">
            {n.label}
          </AnchorLink>
        ))}
      </nav>
      <AnchorLink href="#contact" onClick={onClose} className="mt-auto flex h-14 items-center justify-between bg-ink px-[18px] font-extrabold text-bg">
        Book a free consultation <span aria-hidden="true">→</span>
      </AnchorLink>
    </div>
  );
}
